module.exports = __webpack_public_path__ + "static/P2101477-8bde268fb0e9c62056a20fc543efd071.jpg";